import createIntegrationSubscriptionChannel from '@/store/sagas/createIntegrationSubscriptionChannel'
import { generateAlertNotificationTopic } from '@/constants/socket/events'

export const createAlertNotificationChannel = () => (
  createIntegrationSubscriptionChannel(generateAlertNotificationTopic)
)

export default createAlertNotificationChannel
